// * 영산대 사업소개 라우트

const inhaInfoRoutes = [
  {
    path: "inha-overview",
    children: [
      {
        path: "",
        name: "InhaOverview",
        meta: {
          title: "사업 안내",
          mobileTitle: "사업 안내",
        },
      },
      {
        path: "vision",
        name: "InhaVision",
        meta: {
          title: "비전 및 목표",
          mobileTitle: "비전 및 목표",
        },
      },
      {
        path: "organization",
        name: "InhaOrganization",
        meta: {
          title: "조직도",
          mobileTitle: "조직도",
        },
      },
      {
        path: "directions",
        name: "InhaDirections",
        meta: {
          title: "찾아오시는 길",
          mobileTitle: "찾아오시는 길",
        },
      },
    ],
  },
];

export default inhaInfoRoutes;
